import moment from 'moment';

type Value = string | null | undefined;
type ValueBool = boolean | null | undefined;
export const required = (message: string) => (value: Value) => {
  return value == null || value.length === 0 ? message : undefined;
};

export const minDate = (message: string) => (value: Value) => {
  if (value == null || value === '') {
    return undefined;
  }

  const parsed = moment(value);
  if (!parsed.isValid()) {
    return undefined;
  }

  if (!parsed.isBefore(moment().add(3, 'months'))) {
    return undefined;
  }

  return message;
};

export const maxYearsOld = (message: string, years: number) => (value: Value) => {
  if (value == null || value === '') {
    return undefined;
  }

  const parsed = moment(value);
  if (!parsed.isValid()) {
    return undefined;
  }

  if (!parsed.isBefore(moment().add(-years, 'y'))) {
    return undefined;
  }

  return message;
};

export const needsToBeOne = (message: string) => (value: Value) => (value !== '1' ? message : undefined);

export const checkedRequired = (value: ValueBool) => {
  return value == null || !value ? 'Fehlt' : undefined;
};
export const isOptionalNumber = (value: Value) => {
  if (value == null) {
    return undefined;
  }
  const res = parseInt(value, 10);
  if (isNaN(res)) {
    return 'Benötigt Zahl';
  }
  return undefined;
};
export const isNumber = (message: string) => (value: Value) => {
  if (value == null) {
    return message;
  }
  const res = parseInt(value, 10);
  if (isNaN(res)) {
    return message;
  }
  return undefined;
};

export const isNumberLowerAs = (message: string, lowest: number) => (value: Value) => {
  if (value == null) {
    return message;
  }
  const res = parseInt(value, 10);
  if (isNaN(res) || res > lowest) {
    return message;
  }
  return undefined;
};

export const isDecimal = (value: string | null) => {
  if (value == null) {
    return 'Benötigt';
  }
  if (isNaN(parseFloat(value))) {
    return 'Ungültiger Wert';
  }
  return undefined;
};

export const createIsInt = (message: string): Validator => v =>
  v != null && v !== '' && isNaN(parseInt(v, 10)) ? message : undefined;
export const isInt: Validator = createIsInt('Ungültige Zahl');

export const createIsDate = (message: string): Validator => v =>
  v != null && v !== '' && !v.match(/\d{1,2}\.\d{1,2}.\d{4}?/) ? message : undefined;
export const isDate = createIsDate('Ungültiges Datum');

export const createIsTime = (message: string): Validator => v =>
  v != null && v !== '' && !v.match(/\d{1,2}:\d{2}/) ? message : undefined;
export const isTime = createIsTime('Ungültiges Zeit');

export type Validator<FormFields = any, Props = any> = (
  value: string | null | undefined,
  allValues: FormFields,
  props: Props,
  name: string
) => string | undefined;



// WEBPACK FOOTER //
// ./src/shared/validation.tsx